import { render, staticRenderFns } from "./CourseOrdersCalendarComponent.vue?vue&type=template&id=2c2e1360"
import script from "./CourseOrdersCalendarComponent.vue?vue&type=script&lang=js"
export * from "./CourseOrdersCalendarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports